// Single source of truth for the page's one conversion action.
// Every CTA on the site must use these. Five different labels for the same
// action reopens the decision each time instead of reinforcing it.

// Temporary no-backend booking flow. Keep the WhatsApp destination here so it
// can be replaced in one place when the Calendly integration returns.
export const WHATSAPP_NUMBER = '4915679651349';

export const CTA_LABEL = 'Request My Free 30-Minute Exit Call';

// The cohort the page is currently selling.
export const COHORT_START_DATE = '2026-09-19';
export const COHORT_START = new Intl.DateTimeFormat('en', {
  dateStyle: 'long',
  timeZone: 'UTC',
}).format(new Date(`${COHORT_START_DATE}T00:00:00Z`));
export const COHORT_START_TS = `${COHORT_START_DATE}T00:00:00`;

// Reassurance line that belongs under every booking button. Deliberately says
// what the call IS. It carries no money-back promise: a refund guarantee only
// belongs where money changes hands, never under a free call.
export const CTA_SUBLINE =
  'Free • 30 minutes • 1-on-1, not a group webinar. Nothing to prepare, no card.';

// Kept under its existing export name until Calendly is re-enabled so callers
// elsewhere in the app do not need a temporary compatibility rewrite.
export const openCalendly = () => {
  document.getElementById('booking-request-form')?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
};
